export const MarketplaceMissingEmail = () => (
  <>
    <div>We could not get a valid email from your GitHub account</div>
    <div>
      Please make sure that the right permissions were given or try again with
      another user
    </div>
  </>
);
